<template lang="pug">
    Modal
        .form
            h2  Copy content from another market
            .form__control-group
                label Copy Content from...
                multiselect(
                    v-model="copiedLocale"
                    :options="getAvailableMarkets"
                    :searchable="false"
                    :selectLabel="''"
                    :allow-empty="false"
                    :deselectLabel="''"
                    :multiple="false"
                )
            button.button__submit(
                @click="submit"
            ) Copy and replace volume links
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import Services from '../../services/Services';
import { postResource } from '../../services/Utils.js';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueNotifications from 'vue-notifications';
export default {
    name: 'CopyVolumeLinks',
    components: {
        Modal,
        Multiselect,
    },
    data() {
        return {
            isCopying: false,
            copiedLocale: ''
        }
    },
    computed: {
        getActiveCard() {
            return store.getters.getActiveCard;
        },
        getActiveMarket(){
            return store.getters.getActiveMarket;
        },
        getActiveLocale(){
            return store.getters.getActiveMarket.locale;
        },
        getAvailableMarkets() {
            const markets = store.getters.getMarkets;

            const availableMarkets = [];

            for(const i in markets) {
                const locale = markets[i].locale;
                if(locale !== this.getActiveLocale){
                    availableMarkets.push(locale);
                }
            }

            return availableMarkets;
        },
        getMarketsByLocale() {
            if (this.getAvailableMarkets) {
                let marketsByLocale = [];

                this.getAvailableMarkets.forEach(market => {
                marketsByLocale.push(market.locale);
                });

                return marketsByLocale;
            }
        },
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        icon: '✅'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        icon: '❗️'
        }
    },
    mounted(){
        Services.getMarkets();
    },
    methods: {
        submit(){
            const update = {
                recordId: this.getActiveMarket._id,
                targetLocale: this.getActiveLocale,
                sourceLocale: this.copiedLocale
            }

            console.log(update);

            postResource('/v1/markets/copyVolumeLinks', `id=${this.getActiveMarket._id}`, update)
                .then(res => {
                    console.log('success!', res);
                    this.showSuccessMsg({ message: `Content copied from ${this.copiedLocale}!` });
                    const marketId = this.$route.params.marketId;
                    Services.setActiveMarket(marketId);
                    store.commit('hideModals', true);
                    return res;
                })
                .catch(error => {
                    let message = 'An error occurred. Please try again.';
                    if(error.error){
                        message = error.error;
                    }
                    this.showErrorMsg({
                    message
                    });
                });
        }
    }
}
</script>
<style lang="scss" scoped>
h2 {
    text-align: center;
}

.form {
    padding: 2rem;
}

.form__control-group.rule__control-group--select:after {
    top: 20px;
}

button {
    margin: 2rem auto 0;
}

.copy-content {
    margin-top: 20px;

    div {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CopyVolumeLinks.vue